import React from 'react';

import { formatMoney } from '@betterment/core';
import { Box, Button, H1 } from '@betterment/samba-react';

import { Header } from './Header';
import { SellAllWarningStepProps, toSellAllWarning, toValidatedSellAllWarningOutput } from './types';

import { WorkflowPage } from '../../../Shared/Components/WorkflowPage';

export const SellAllWarning: React.FC<SellAllWarningStepProps> = ({ goToStep, navigate, flowState }) => {
  const onCancel = () => {
    void navigate(flowState.returnToPath);
  };

  const onBack = () => {
    goToStep('new', flowState.values);
  };

  const { amount, assetName, coordinatedAccount } = toSellAllWarning(flowState.values);

  return (
    <WorkflowPage>
      <Header onCancel={onCancel} onBack={onBack}>
        Sell order
      </Header>
      <WorkflowPage.Main>
        <Box
          css={{
            alignSelf: 'center',
            maxWidth: '584px',
            display: 'flex',
            flexDirection: 'column',
            rowGap: 'space.400',
          }}
        >
          <H1 color="text" variant="pageTitle">
            You’re about to sell your client’s entire position in {assetName}
          </H1>
          <Box>
            <p>
              {formatMoney(amount)} is greater than 90% of the available amount of{' '}
              {formatMoney(coordinatedAccount.amount)} for the selected position.
            </p>
            <p>
              Partial sell orders are only supported when the amount is less than 90% of the total position. The value
              of your order may fluctuate due to market volatility before the trade completes.
            </p>
            <p>Any upcoming dividends will be deposited and reinvested into your client's investing account.</p>
          </Box>
          <Box>
            <Button
              variant="solidPrimary"
              type="submit"
              onClick={() => goToStep('review', { ...toValidatedSellAllWarningOutput(flowState.values) })}
            >
              Continue
            </Button>
          </Box>
        </Box>
      </WorkflowPage.Main>
    </WorkflowPage>
  );
};
